import { getMajorChordFromNoteNumber,
  getMinorChordFromNoteNumber, getDiminshedChordFromNoteNumber,
 getAugmentedChordFromNoteNumber, lookup } from '../utils/chord-builder';
import { observable, computed } from 'mobx';
import { getRandomIndexFromProbabilityMass,
  getRandomInt } from '../utils/game-helpers';
import Stage from './stage-store';
class ChordStore {

  possibleTunings = [-1.0, -0.5, 0.5, 1.0];
  @observable stages = [];
  @observable currentStage = null;
  passThresh = 3;
  @computed get total() {
    return this.stages.reduce( (acc, stage) => {
      if (stage.correct !== null) {
        acc++;
      }
      return acc;
    }, 0);
  }
  @computed get numberCorrect() {
    return this.stages.reduce( (acc, stage) => {
      if (stage.correct === true) {
        acc++;
      }
      return acc;
    }, 0);
  }

  @computed get percent() {
    if (this.total === 0) {
      return 0;
    }
    else {
      return Math.round(this.numberCorrect /
        this.total*100);
    }
  }
  getNewStage() {
    const newStage = this.getStage();
    this.currentStage = newStage;
    this.stages.push(newStage);
    return newStage;
  }

  getRandomTriadFromBase(base) {
    //get random with distro, set name, reverse array from chord builder
    // put major last for edge case of floating point in getRandomIndexFromProbabilityMass
    // encode diminished 0, augmented 1, minor 2, major 3
    const letter = lookup[parseInt(base % 12, 10)];
    const type = getRandomIndexFromProbabilityMass([0.125, 0.125, 0.375, 0.375])
    let files;
    let label = null;
    if (type === 0) {
      files = getDiminshedChordFromNoteNumber(base);
      label = `${letter}dim`;
    }
    else if ( type === 1 ) {
      files = getAugmentedChordFromNoteNumber(base);
      label = `${letter}aug`;
    }
    else if ( type === 2 ) {
      files = getMinorChordFromNoteNumber(base);
      label = `${letter}min`;
    }
    else {
      files = getMajorChordFromNoteNumber(base);
      label = `${letter}maj`;
    }
    return {files: files, label};
  }
  getStage() {
    //note 75 for aug chord
    const base = getRandomInt(36, 75);
    const {files, label} = this.getRandomTriadFromBase(base);
    const indexToDetune = getRandomInt(0, files.length);
    const chosenOffset = this.possibleTunings[Math.floor(Math.random()*this.possibleTunings.length)];
    const offSetArr = files.map( (_f, indx) => indx === indexToDetune? chosenOffset : 0 );
    return new Stage(files.reverse(), offSetArr, label);
  }
}
export const observableChordStore = new ChordStore();



// WEBPACK FOOTER //
// ./src/stores/chord-store.js